import * as AvatarPrimitive from '@radix-ui/react-avatar';
import * as React from 'react';

import { cn } from '@/lib/utils';

const AvatarImage = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image> &
  React.RefAttributes<React.ElementRef<typeof AvatarPrimitive.Image>>) => (
  <AvatarPrimitive.Image ref={ref} className={cn('aspect-square h-full w-full object-cover', className)} {...props} />
);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

export { AvatarImage };
